import { CdkScrollableModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { LocalStorageKeyBuilder } from '@recruitee/common';
import { EmojiModule } from '@recruitee/emoji';
import { I18nModule, LANGUAGE_CONFIG, LanguageConfig, LOCALE } from '@recruitee/i18n';
import { ProsemirrorModule } from '@recruitee/prosemirror/angular';
import { PipesModule, RtUIModule } from '@recruitee/user-interface';

import { AppComponent } from './app.component';

export class KeyBulder extends LocalStorageKeyBuilder {
  public buildScopedKey(key: string): string {
    return key;
  }
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    RtUIModule.forRoot(),
    I18nModule.forPhraseApp({ phraseAppProjectId: '' }),
    ProsemirrorModule,
    CdkScrollableModule,
    EmojiModule,
    PipesModule,
  ],
  providers: [
    { provide: LOCALE, useValue: 'en' },
    { provide: LocalStorageKeyBuilder, useClass: KeyBulder },
    {
      provide: LANGUAGE_CONFIG,
      useValue: <LanguageConfig>{ defaultLanguage: 'en', languages: ['en'] },
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
